import {Injectable} from '@angular/core';
import {Observable} from "rxjs/Observable";
import {AppSettings} from "../app.settings";
import {Base2Service} from "./base2.service";
import {ResponseApi} from "./response/response";
import {HttpHeaders} from "@angular/common/http";

@Injectable()
export class RequestService extends Base2Service {

    getTypes(): Observable<ResponseApi> {
        return this.request<ResponseApi>("GET", AppSettings.apiUrl + 'requeststypes');

    }

    getSubTypes(id: number): Observable<ResponseApi> {
        return this.request<ResponseApi>("GET", AppSettings.apiUrl + 'requeststypes/sub/' + id);
    }

    addTypes(object: any): Observable<any> {
        return this.request<ResponseApi>("POST", AppSettings.apiUrl + 'requests/', JSON.stringify(object));
    }

    getKladr(query: string): Observable<any> {
        var beginTime = Date.now();
        let headers = new HttpHeaders({
            'Authorization': "Token 59b1609de246dc4e4f0c7c5eac29948c1924c1e7"
        });
        return this.request<any>("POST", "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address", {
            query: query,
            count: 1
        }, headers);
    }

    getAllByAgent(id): Observable<ResponseApi> {
        return this.request<ResponseApi>("GET", AppSettings.apiUrl + 'requests/agent/' + id);
    }
}
